import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useTawkVisibility = () => {
  const stagLocation = useLocation();
  const location = stagLocation.pathname;
  const isAuthenticated = localStorage.getItem('token');
  const showRoutes = ['/workload-landing-v2', '/workload-landing'];

  const shouldShow = (pathname: string) => {
    if (showRoutes.includes(pathname)) return true;
    if (location.startsWith('/workload-landing-v2')) return true;
    if (location.startsWith('/workload-landing')) return true;

    return false;
  };

  useEffect(() => {
    const handleVisibility = () => {
      const isShow = shouldShow(location);

      if (!window.Tawk_API) {
        const interval = setInterval(() => {
          if (window.Tawk_API) {
            handleVisibility();
            clearInterval(interval);
          }
        }, 200);

        return () => clearInterval(interval);
      }

      if (isShow) {
        window.Tawk_API.showWidget();
      } else {
        window.Tawk_API.minimize();
        window.Tawk_API.hideWidget();
      }
    };
    handleVisibility();
  }, [location, isAuthenticated]);
};
